import { CSSProperties } from 'react';

export const desktopBookingCardHeight = 96;

export const desktopBookingCardStyle: CSSProperties = {
  height: `${desktopBookingCardHeight}px`,
};
